/* eslint-disable */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, MenuItem, Select, FormControl, InputLabel } from "@mui/material";

function RelatedDropDownsField({
  displayNameParent,
  displayNameChild,
  fieldRefParent,
  fieldRefChild,
  relatedOptions,
}) {
  const [parentOptions, setParentOptions] = useState([]);
  const [selectedParentOption, setSelectedParentOption] = useState(null);
  const [childFieldOptions, setChildFieldOptions] = useState([]);

  useEffect(() => {
    const pOts = [];
    for (const row of relatedOptions) {
      pOts.push(row.parent);
    }
    setParentOptions(pOts);
  }, []);

  useEffect(() => {
    if (selectedParentOption === null) {
      return;
    }

    let cOts = [];
    for (const row of relatedOptions) {
      if (row.parent === selectedParentOption) {
        cOts = row.child.split(",");
      }
    }
    setChildFieldOptions(cOts);
  }, [selectedParentOption]);

  return (
    <Box mt={4}>
      <Box>
        <FormControl sx={{ minWidth: 120, width: "100%" }}>
          <InputLabel>{displayNameParent}</InputLabel>
          <Select
            name={fieldRefParent}
            label={displayNameParent}
            sx={{ padding: "12px", paddingLeft: "3px" }}
            onChange={(e) => setSelectedParentOption(e.target.value)}
          >
            {parentOptions.map((option) => (
              <MenuItem value={option}>{option}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box mt={4}>
        <FormControl sx={{ minWidth: 120, width: "100%" }}>
          <InputLabel>{displayNameChild}</InputLabel>
          <Select
            name={fieldRefChild}
            label={displayNameChild}
            sx={{ padding: "12px", paddingLeft: "3px" }}
          >
            {childFieldOptions.map((option) => (
              <MenuItem value={option}>{option}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
}

// Typechecking props of the Transaction
RelatedDropDownsField.propTypes = {
  displayNameParent: PropTypes.string.isRequired,
  displayNameChild: PropTypes.string.isRequired,
  fieldRefParent: PropTypes.string.isRequired,
  fieldRefChild: PropTypes.string.isRequired,
  relatedOptions: PropTypes.arrayOf(PropTypes.any),
};

RelatedDropDownsField.defaultProps = {
  relatedOptions: [],
};
export default RelatedDropDownsField;
